import { render, staticRenderFns } from "./JJDialog.vue?vue&type=template&id=6b0625f8&scoped=true"
import script from "./JJDialog.vue?vue&type=script&lang=js"
export * from "./JJDialog.vue?vue&type=script&lang=js"
import style0 from "./JJDialog.vue?vue&type=style&index=0&id=6b0625f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0625f8",
  null
  
)

export default component.exports